<template>
    <div class="flex m-0 border-gray-200 draggable hover:z-20">

        <!-- Draggable handle. -->
        <div class="w-6 py-1.5 m-0 -mt-px border-t border-b bg-white">
            <div class="w-5 h-5 flex items-center pl-1">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"
                   v-if="!estimate.readonly"></i>
            </div>
        </div>

        <div class="flex-1 -ml-px mr-px -mt-px">
            <div class="flex ml-px mr-px">
                <!-- Component -->
                <estimate-task-item-component :estimate="estimate" :item="labour" :ref="'component'" @componentUpdated="updateComponent"></estimate-task-item-component>
                <!-- Item. -->
                <estimate-task-item-labour-search
                    class="flex-1 flex "
                    #default="{ open, query, setQuery }"
                    :store="store"
                    :estimate="estimate"
                    @selected:labourRate="labourRateSelected"
                    :top="true"
                >
                    <!-- Name. -->
                    <div class="flex-1 flex -ml-px m-0 relative">
                        <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'"
                                                ref="autoresizable-textarea" v-if="!estimate.readonly">
                <textarea
                    placeholder="Name..."
                    class="text-sm m-0 px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                    type="text"
                    ref="name"
                    v-model="labour.name"
                    rows="1"
                    @input="setQuery($event.target.value);updateName()"
                    @focus="setQuery($event.target.value);open()"
                    @change="estimate.buildCollectedItems()"
                ></textarea>
                        </autoresizable-textarea>
                        <div v-else
                             class="text-sm w-full m-0 px-2 py-1.5 border border-gray-200 whitespace-pre-wrap shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                             v-text="labour.name"
                        ></div>
                        <div class="absolute bottom-1.5 right-1 z-20" v-if="!editAsAssembly">
                            <button class="p-0.5 w-5 h-5 text-xs text-gray-300 hover:text-blue-400"
                                    @click="toggleNotes">
                                <i class="far fa-edit"></i>
                            </button>
                        </div>
                    </div>
                </estimate-task-item-labour-search>

                <!-- Rate. -->
                <div class="w-24 -ml-px flex">
                    <estimate-task-item-labour-calc-dropdown #default="{ open:openLabour, close:closeLabour }"
                                                             class="flex-1"
                                                             :item="item"
                                                             :labour="labour"
                                                             :align-right="true"
                                                             :readonly="estimate.readonly"
                                                             @apply="(e) => {rate = e;updateRate();}"
                                                             menu-class="w-96"
                                                             trigger-class="flex w-full">
                        <page-cell
                            currency
                            class="text-sm m-0 px-2 py-1.5 border border-gray-200 bg-white"
                            placeholder="Rate..."
                            :read-only="estimate.readonly"
                            v-model="rate"
                            ref="rate"
                            @focus="() => {focusedRate();closeLabour();}"
                            @input="updateRate"
                            @change="updateAll"
                        ></page-cell>
                        <div class="absolute bottom-1.5 right-1 z-20">
                            <button class="p-0.5 w-5 h-5 text-xs text-gray-300 hover:text-blue-400"
                                    @click="openLabour">
                                <i class="fas fa-calculator"></i>
                            </button>
                        </div>
                    </estimate-task-item-labour-calc-dropdown>
                </div>
                <!-- Total. -->
                <div class="w-28 -ml-px flex" v-if="!editAsAssembly">
                    <estimate-task-item-labour-calc-dropdown #default="{ open:openLabour, close:closeLabour }"
                                                             class="flex-1"
                                                             :item="item"
                                                             :labour="labour"
                                                             :align-right="true"
                                                             :readonly="estimate.readonly"
                                                             @apply="(e) => {rate = e;updateRate();}"
                                                             menu-class="w-96"
                                                             trigger-class="flex w-full">
                        <page-cell v-if="item.quantity"
                                   currency
                                   class="text-sm m-0 px-2 py-1.5 border border-gray-200 bg-white"
                                   placeholder="Total..."
                                   :read-only="estimate.readonly"
                                   v-model="total"
                                   ref="total"
                                   @focus="() => {updateTotal();closeLabour();}"
                                   @input="updateTotal"
                                   @change="updateAll"
                        ></page-cell>
                        <page-cell v-else
                                   class="text-sm m-0 px-2 py-1.5 border border-gray-200 text-red-400 bg-white"
                                   read-only
                                   value="???"
                        ></page-cell>
                        <div class="absolute bottom-1.5 right-1 z-20">
                            <button class="p-0.5 w-5 h-5 text-xs text-gray-300 hover:text-blue-400"
                                    @click="openLabour">
                                <i class="fas fa-calculator"></i>
                            </button>
                        </div>
                    </estimate-task-item-labour-calc-dropdown>
                </div>
            </div>
            <div class="m-0 py-px pb-2" v-if="this.shownotes && !editAsAssembly">
                <div class="m-0 px-px py-px pb+px flex">
                    <div class="w-10 text-gray-700 text-xs pt-0.5 pb-0.5 pl-2 font-medium">Notes:</div>
                    <div class="flex-1">
                        <autoresizable-textarea :height="el => (el.scrollHeight + 1) + 'px'"
                                                ref="notes-textarea" v-if="!estimate.readonly">
                            <textarea
                                placeholder="..."
                                class="col-span-full text-gray-700 text-xs pt-0.5 ml-2  pb-0.5 border-none shadow-none relative hover:z-10 focus:z-20 resize-none focus:ring-0"
                                type="text"
                                ref="notes"
                                v-model="labour.notes"
                                rows="1"
                                @input="estimate.update()"
                                @blur="estimate.update()"
                            ></textarea>
                        </autoresizable-textarea>
                        <div v-else
                             class="w-full whitespace-pre-wrap text-gray-700 text-xs ml-2 pt-0.5 pb-0.5 border-none shadow-none relative hover:z-10 focus:z-20 resize-none focus:ring-0"
                             v-text="labour.notes"
                        ></div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Dropdown. -->
        <div class="w-6 pt-2 m-0 -ml-px -mt-px border-t border-b bg-white">
            <ui-dropdown menu-class="p-3 w-64">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-cut" @click="cutLabour();close();" v-if="!estimate.readonly">Cut
                        Labour
                    </ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-copy" @click="copyLabour();close();">Copy Labour
                    </ui-dropdown-item>
                    <ui-dropdown-item icon="fas fa-paste" @click="pasteLabour();close();"
                                      v-if="labourClipboard.length && !estimate.readonly">
                        {{
                            'Paste Labour' + (labourClipboard.length > 1 ? 's' : '') + ' (' + labourClipboard.length + ')'
                        }}
                    </ui-dropdown-item>
                    <hr v-if="labourClipboard.length" class="m-1.5"/>
                    <ui-dropdown-item icon="fas fa-clipboard" @click="clearClipboard();close();"
                                      v-if="labourClipboard.length">
                        {{ 'Empty Labour clipboard' }}
                    </ui-dropdown-item>
                    <hr v-if="!estimate.readonly" class="m-1.5"/>
                    <ui-dropdown-item icon="fas fa-trash" v-if="!estimate.readonly" danger
                                      @click="deleteLabour();close();">Delete
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>

    </div>
</template>

<script>
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import {cloneDeep, trim} from "lodash";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import {resolveNumericText} from "../../../../utils";
import EstimateTaskItemMaterialSearch from "./EstimateTaskItemMaterialSearch.vue";
import EstimateTaskItemLabourSearch from "./EstimateTaskItemLabourSearch.vue";
import PageCell from "../../../ui/PageCell.vue";
import remoteStorage from "../../../../utils/remoteStorage";
import EstimateCostListUpdateMaterialDropdown from "../cost-list/EstimateCostListUpdateMaterialDropdown.vue";
import EstimateTaskItemLabourCalcDropdown from "./EstimateTaskItemLabourCalcDropdown.vue";
import EstimateTaskItemComponent from "./EstimateTaskItemComponent.vue";

export default {
    components: {
        EstimateTaskItemComponent,
        EstimateTaskItemLabourCalcDropdown,
        EstimateCostListUpdateMaterialDropdown,
        PageCell,
        EstimateTaskItemLabourSearch, EstimateTaskItemMaterialSearch, UiDropdownItem, AutoresizableTextarea
    },
    props: {
        labour: Object,
        item: Object,
        editAsAssembly:false,
        estimate: Object,
        store: Object,
        labourClipboard: Array,
    },
    data() {
        return {
            shownotes: this.labour.notes !== '',
            rate: this.labour.rate,
            quantity: this.labour.quantity,
            total: this.labour.total,
            updating: false,
            resolveNumericText,
            color:'#FFFFFF',
        }
    },
    watch: {
        item: {
            handler(newValue, oldValue) {
                if (!this.updating) {
                    this.total = this.labour.total
                    this.rate = this.labour.rate
                    this.quantity = this.labour.quantity
                }
            },
            deep: true,
        },
    },
    methods: {
        updateName() {
            this.$emit('assemblyUpdated',this.item)
            this.estimate.update()
        },
        labourRateSelected({labourRateName, labourRateCost}) {
            this.labour.name = trim(labourRateName);
            this.rate = parseFloat(('' + labourRateCost).replace(/[^0-9.]/g, ''));
            this.updateRate();
        },
        toggleNotes() {
            this.shownotes = !this.shownotes
        },
        focusedRate() {
            this.rate = Math.round(parseFloat(this.rate === '.' ? '0.' : this.resolveNumericText(this.rate)) * 100) / 100
        },
        updateComponent() {
            this.$emit('assemblyUpdated', this.item)
            this.estimate.update()
        },
        updateRate() {
            this.updating = true;
            let value = parseFloat(this.rate === '.' ? '0.' : this.resolveNumericText(this.rate))
            this.labour.rate = isNaN(value) ? 0 : value;
            this.labour.total = this.item.quantity * this.labour.rate
            this.$emit('assemblyUpdated',this.item)
            this.estimate.update();
            this.total = parseFloat(this.labour.total);
        },
        updateTotal() {
            this.updating = true;
            let value = parseFloat(this.total === '.' ? '0.' : this.resolveNumericText(this.total));
            this.labour.total = isNaN(value) ? 0 : value;
            this.labour.rate = this.labour.total / this.item.quantity
            this.estimate.update();
            this.rate = parseFloat(this.labour.rate);
        },
        updateAll() {
            this.rate = parseFloat(this.labour.rate);
            this.total = parseFloat(this.labour.total);
            this.estimate.buildCollectedItems()
            this.updating = false;
        },
        deleteLabour() {
            this.$emit('assemblyItemRemoved',this.labour,'labour')
        },
        cutLabour() {
            this.labourClipboard.length = 0;
            this.labourClipboard.push(this.labour);
            remoteStorage.setItem('estimate-labour-clipboard', JSON.stringify(this.labourClipboard))
            this.$emit('assemblyItemRemoved',this.labour,'labour')
        },
        copyLabour() {
            this.labourClipboard.length = 0;
            this.labourClipboard.push(cloneDeep(this.labour))
            remoteStorage.setItem('estimate-labour-clipboard', JSON.stringify(this.labourClipboard))
        },
        pasteLabour() {
            let num = this.item.labour.indexOf(this.labour);
            this.labourClipboard.forEach((t, index) => {
                let labour = cloneDeep(t);
                this.item.labour.splice(num + index + 1, 0, labour);
                this.$emit('assemblyItemAdded',labour,'labour')
            });
            this.estimate.update()
        },
        clearClipboard() {
            this.labourClipboard.length = 0;
            remoteStorage.setItem('estimate-labour-clipboard', JSON.stringify(this.labourClipboard));
        },
    },
}
</script>
